<template>

    <div class="row">
        <div class="col-md-8 col-md-offset-2">

            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Lidmaatschap</h2>
                </div>
                <div class="box-body">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="members.length === 0">
                                <td colspan="2">Dit team heeft nog geen leden.</td>
                            </tr>
                            <tr v-for="(fullName, userId) in members">
                                <td>
                                    {{ fullName }}
                                </td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-xs">
                                        <button
                                            class="btn btn-danger btn-xs"
                                            @click="removeFromTeam(userId)"
                                            v-tooltip="'Uit team verwijderen'"
                                        >
                                            <i class="mdi mdi-close"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                    <label for="addToTeam">Toevoegen:</label>
                                    <select id="addToTeam" class="d-none" v-model="addUserId" @change="addToTeam">
                                        <option value="">Kies een gebruiker</option>
                                        <option
                                            v-for="(fullName, userId) in candidates"
                                            :value="userId"
                                            v-text="fullName"
                                        ></option>
                                    </select>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
            </div>

        </div>
    </div>

</template>

<script>

import axios from "axios";

export default {

    data() {
        return {
            loading:false,
            candidates:[],
            members:[],
            addUserId:'',
        }
    },

    methods: {
        getTeamCandidates() {
            axios.get(this.route('api.v1.hr.teams.members.fetch', {id: this.team.id, type:'candidates'}))
                .then(resp => {
                    this.candidates = resp.data;
                    window.jQuery('#member_add').show();
                });
        },

        getTeamMembers() {
            this.loading = true;
            axios.get(this.route('api.v1.hr.teams.members.fetch', {id: this.team.id, type:'members'}))
                .then(resp => {
                    this.members = resp.data;
                    this.loading = false;
                });
        },

        addToTeam() {
            if (this.addUserId != '') {
                axios.post(this.route('api.v1.hr.teams.members.add', {id: this.team.id, user_id: this.addUserId}))
                    .then(resp => {
                        if (resp.data.success) {
                            this.reloadData();
                            this.$snotify.success('De gebruiker is toegevoegd aan het team.');
                        } else {
                            this.$snotify.error('Er is een fout opgetreden bij het toevoegen.');
                        }
                    });
            }
        },

        removeFromTeam(user_id) {
            axios.post(this.route('api.v1.hr.teams.members.remove', {id: this.team.id, user_id: user_id}))
                .then(resp => {
                    if (resp.data.success) {
                        this.reloadData();
                        this.$snotify.success('De gebruiker is verwijderd uit het team.');
                    } else {
                        this.$snotify.error('Er is een fout opgetreden bij het verwijderen.');
                    }
                });
        },

        loadData() {
            this.getTeamCandidates();
            this.getTeamMembers();
        },

        reloadData() {
            this.loadData();
            this.addUserId = '';
            this.$forceUpdate();
        }
    },

    mounted() {
        this.loadData();
    },

    name:'HrTeamMembership',

    props: {
        team: {
            type:Object,
        },
    },

}

</script>
